import * as types from './constants'
import apiService from '../../apiService/apiService'

export const initialData = (image) => {
    return (dispatch) => {
        dispatch({
            type: types.INITIAL_DATA,
        })
    }
}

export const saveData = (roomId, newData) => {
    const data = {
        projectData: JSON.stringify({ layers: newData }),
    }
    return (dispatch) => {
        dispatch({
            type: types.SAVE_DATA_STARTED,
        })
        apiService.rooms
            .update(roomId, data)
            .then((response) => {
                if (response.status == '200' || response.status == '204') {
                    dispatch({
                        type: types.SAVE_DATA_SUCCESS,
                    })
                    window.location.reload()
                } else {
                    dispatch({
                        type: types.SAVE_DATA_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.SAVE_DATA_FAILED,
                    error: errorMessage,
                })
            })
    }
}
